//GeneratorFlag:[NoChange]
export default {
	path: 'product-group',
	name: 'store.basis.productGroup.layout',
	redirect: to => {
		return {name: 'store.productGroup.list'};
	},
	component: () => import('@/modules/store/views/layout.vue'),
	meta: {
		requiresAuth: true,
		serverAccessKeys:[],
		clientAccessKeys:["/store/basis/product-group"],
		resourceKey: 'store.productGroupLayout',
		menuConfig: {
			isVisible: true,
			iconName: 'bi-link-45deg',
		}
	},
	children: [
//GeneratorFlag:[ProductGroupCreate]"
		{
			path: 'create',
			name: 'store.productGroup.create',
			component: () => import('@/modules/store/views/product-group/product-group-create.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'store.productGroupCreate',
				clientAccessKeys:["/store/basis/product-group/create"],
				serverAccessKeys:["/store/product-group/create","/store/product-group/stream-create"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[ProductGroupCreateImport]"
		{
			path: 'create-import',
			name: 'store.productGroup.createImport',
			component: () => import('@/modules/store/views/product-group/product-group-create-import.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'store.productGroupCreateImport',
				clientAccessKeys:["/store/basis/product-group/create-import"],
				serverAccessKeys:["/store/product-group/create","/store/product-group/stream-create"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[ProductGroupDelete]"
		{
			path: 'delete',
			name: 'store.productGroup.delete',
			component: () => import('@/modules/store/views/product-group/product-group-delete.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'store.productGroupDelete',
				clientAccessKeys:["/store/basis/product-group/delete"],
				serverAccessKeys:["/store/product-group/delete","/store/product-group/stream-delete"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[ProductGroupDetail]"
		{
			path: 'detail',
			name: 'store.productGroup.detail',
			component: () => import('@/modules/store/views/product-group/product-group-detail.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'store.productGroupDetail',
				clientAccessKeys:["/store/basis/product-group/detail"],
				serverAccessKeys:["/store/product-group/detail"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[ProductGroupList]"
		{
			path: 'list',
			name: 'store.productGroup.list',
			component: () => import('@/modules/store/views/product-group/product-group-list.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'store.productGroupList',
				clientAccessKeys:["/store/basis/product-group/list"],
				serverAccessKeys:["/store/product-group/list"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[ProductGroupAttachment]"
		{
			path: 'attachment',
			name: 'store.productGroup.attachment',
			component: () => import('@/modules/store/views/product-group/product-group-attachment.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'store.productGroupAttachment',
				clientAccessKeys:["/store/basis/product-group/attachment"],
				serverAccessKeys:["/store/product-group/list"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[ProductGroupImageAttachment]"
		{
			path: 'image-attachment',
			name: 'store.productGroup.imageAttachment',
			component: () => import('@/modules/store/views/product-group/product-group-image-attachment.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'store.productGroupImageAttachment',
				clientAccessKeys:["/store/basis/product-group/image-attachment"],
				serverAccessKeys:["/store/product-group/list"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[ProductGroupUpdate]"
		{
			path: 'update',
			name: 'store.productGroup.update',
			component: () => import('@/modules/store/views/product-group/product-group-update.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'store.productGroupUpdate',
				clientAccessKeys:["/store/basis/product-group/update"],
				serverAccessKeys:["/store/product-group/update"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[NewRoute]
	]
}